import React, { Component } from 'react'
import './Ranking.css'
import { database, ref, get, query, orderByValue, child } from '../../firebase'
import Loading from '../commons/Loading'

class Ranking extends Component {
  constructor (props) {
    super(props)
    this.state = {
      rows: [],
      members: [],
      jornadas: [],
      jornada: false,
      fecha: '',
      active: true,
      loaded: false
    }
    this.getData = this.getData.bind(this)
  }
  componentDidMount () {
    this.getData(this.props.groupId)
      .then((data) => {
        this.setState({
          rows: data.rows,
          jornadas: data.jornadas,
          members: data.members,
          active: data.active,
          loaded: true
        })
      })
  }
  componentDidUpdate (prevProps) {
    if (this.props.groupId !== prevProps.groupId) {
      this.getData(this.props.groupId)
        .then((data) => {
          this.setState({
            rows: data.rows,
            jornadas: data.jornadas,
            members: data.members,
            active: data.active,
            loaded: true
          })
        })
    }
  }
  getData (groupId) {
    return new Promise((resolve, reject) => {
      this.setState({
        loaded: false
      })
      const rows = []
      const promises = []
      const jornadas = []
      let members, mode, active
      const puntajeRef = ref(database, 'grupos/puntaje/' + groupId + '/global')
      const q = query(puntajeRef, orderByValue())
      get(q)
        .then((snap) => {
          const puntajes = []
          snap.forEach((child) => {
            puntajes.push({
              id: child.key,
              points: child.val()
            })
          })
          puntajes.reverse()
          puntajes.forEach((user, i) => {
            promises[i] = new Promise((resolve, reject) => {
              get(child(ref(database, 'usuarios/index'), user.id))
                .then((snap) => {
                  rows[i] = {
                    user: {
                      name: snap.val().name,
                      photo: snap.val().photo,
                      id: user.id
                    },
                    pos: i + 1,
                    pts: user.points
                  }
                  resolve()
                })
                .catch((err) => {
                  reject(err)
                })
            })
          })
          return Promise.all(promises)
        })
        .then(() => {
          return get(child(ref(database, 'grupos/index/' + groupId), 'mode'))
        })
        .then((snap) => {
          mode = snap.val()
          return get(ref(database, 'quinielas/index/' + mode))
        })
        .then((snap) => {
          snap.forEach((child, i) => {
            jornadas.push({
              id: child.key,
              active: child.val().active,
              current: child.val().current,
              fecha: child.val().fecha,
              mode: mode
            })
          })
          jornadas.sort((a, b) => {
            if (a.desde > b.desde) {
              return 1
            }
            if (a.desde < b.desde) {
              return -1
            }
            return 0
          })
          members = rows.map((row) => ({
            name: row.user.name,
            photo: row.user.photo,
            id: row.user.id
          }))
          return get(child(ref(database, 'quinielas/modalidades/' + mode), 'active'))
        })
        .then((snap) => {
          active = snap.val()
          resolve({rows, jornadas, members, active})
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
  render () {
    if (this.state.loaded) {
      return (
        <div className='ranking'>
          <div className='ranking__section'>
            <h2>Jornadas</h2>
            <div className='ranking__jornadas'>
              <div className='ranking__jornadas__content' style={{width: this.state.jornadas.length * 56 + 'px'}}>
                {this.state.jornadas.map((jornada, i) => <Jornada {...jornada} key={jornada.id} n={i} members={this.state.members} handleModal={this.props.handleModal} groupId={this.props.groupId} />)}
              </div>
            </div>
          </div>
          {!this.state.active && <div className='ranking__section'>
            <Finished puntajes={this.state.rows} />
          </div>}
          <div className='ranking__section'>
            <h2>Global</h2>
            {this.state.rows.map((row) => <Row {...row} key={row.user.id} />)}
          </div>
        </div>
      )
    }
    return (
      <div className='ranking'>
        <div className='ranking__loading'>
          <Loading />
        </div>
      </div>
    )
  }
}

const Row = (props) => (
  <div className='ranking__row'>
    <div className='ranking__row__image'>
      <img src={props.user.photo} alt={props.user.name} />
    </div>
    <div className='ranking__row__info'>
      <div>
        <span className='ranking__row__position'>{props.pos}</span>
        <span className='ranking__row__name'>{props.user.name.length > 24 ? props.user.name.substring(0, 24) + '...' : props.user.name}</span>
      </div>
      <div>
        <span className='ranking__row__points'>{props.pts} pts.</span>
      </div>
    </div>
  </div>
)

const Jornada = (props) => {
  if (!props.active) {
    return (
      <a href='#jornada' className='ranking__jornadas__btn' onClick={(ev) => { ev.preventDefault(); props.handleModal('jornadaView', { title: props.fecha, id: props.id, groupId: props.groupId, mode: props.mode, members: props.members }) }}>J{props.n + 1}</a>
    )
  } else {
    return <a className='ranking__jornadas__btn ranking__jornadas__btn--disabled'>J{props.n + 1}</a>
  }
}

const Finished = (props) => {
  const highValue = props.puntajes[0].pts
  const ganadores = props.puntajes.filter((item) => item.pts === highValue)
  return (
    <div className='ranking__finished'>
      <h1>¡Finalizada!</h1>
      <p>La quiniela terminó.<br />¡Felicidades a los ganadores!</p>
      <div className='ranking__finished__row'>
        {ganadores.map((ganador) => (<div className='ranking__finished__winner' key={ganador.user.id}>
          <div className='ranking__finished__winner__image'>
            <img src={ganador.user.photo} alt={ganador.user.name} />
          </div>
        </div>))}
      </div>
    </div>
  )
}

export default Ranking
